// The one switch between the mock API (MSW in the browser) and the live backend.
export type ApiMode = "mock" | "live";

export const API_MODE: ApiMode = import.meta.env.VITE_API_MODE === "live" ? "live" : "mock";

/**
 * Backend origin. Unset: http://localhost:8080 (cross-origin, cookie + CORS).
 * Empty string: same origin, through the dev/preview server's /admin/v1 proxy.
 */
export const API_BASE: string = (import.meta.env.VITE_API_BASE ?? "http://localhost:8080").replace(/\/+$/, "");

export const ADMIN_PREFIX = "/admin/v1";

/** The public web origin, for team invite links (`<origin>/t/<code>`) the API doesn't spell out. */
export const WEB_ORIGIN: string = (import.meta.env.VITE_WEB_ORIGIN || "https://iqdaily.app").replace(/\/+$/, "");
